import { GenericAccordion, FieldRow } from '../SettingsUI';
import type { FieldSetting } from '../../types';

const FIELDS = [
  { label: 'Company Name', key: 'companyName' },
  { label: 'Company Information', key: 'companyInfo' },
  { label: 'Company Position', key: 'companyPosition' }
];

interface CompanyPanelProps {
  fieldSettings: Record<string, FieldSetting>;
  updateField: (
    key: string,
    role: 'mentee' | 'mentor' | 'admin' | 'mandatory',
    value: boolean
  ) => void;
}

export function CompanyPanel({ fieldSettings, updateField }: CompanyPanelProps) {
  return (
    <GenericAccordion title="Company">
      {FIELDS.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={fieldSettings[key]}
          onChange={(role, val) => updateField(key, role, val)}
          onMandatoryChange={(val) => updateField(key, 'mandatory', val)}
        />
      ))}
    </GenericAccordion>
  );
}
